<span
  *ngIf="useMask"
  class="icp-icon"
  [attr.title]="title || null"
  [style.--icp-icon-url]="cssMaskUrl"
  [style.--icp-icon-color]="color || null"
  [style.width]="pxWidth"
  [style.height]="pxHeight"
  [style.display]="inline ? 'inline-block' : 'block'"
  aria-hidden="false"
></span>

<img
  *ngIf="!useMask && url"
  [attr.title]="title || null"
  [src]="url"
  [style.width]="pxWidth"
  [style.height]="pxHeight"
  [style.display]="inline ? 'inline-block' : 'block'"
  alt=""
/>
